import { axios, path } from './config';
import qs from 'qs';

export function addFacebookMapping({ facebookToken, pageId, sequenceId }) {
  const params = {
    facebook_token: facebookToken,
    page_id: pageId,
    sequence_id: sequenceId,
  };

  return axios.post(`${path.ADD_FACEBOOK_MAPPING}${qs.stringify(params)}`);
}

export function updateFacebookMapping({ mappingId, sequenceId, facebookToken }) {
  const params = {
    id: mappingId,
    sequence_id: sequenceId,
    facebook_token: facebookToken,
  };

  return axios.post(path.UPDATE_FACEBOOK_MAPPING + qs.stringify({ ...params }));
}

export function removeFacebookMapping({ mappingId }) {
  const params = {
    id: mappingId,
  };

  return axios.post(path.REMOVE_FACEBOOK_MAPPING + qs.stringify({ ...params }));
}
